import { ascend, prop, sortWith } from 'ramda';

export const SORT_NAME_ASC = 'SORT_NAME_ASC';

const sorting = {
    [SORT_NAME_ASC]: sortWith([ascend(prop('Name'))]),
};

export function sortBuckets(buckets, type = SORT_NAME_ASC) {
    return sorting[type](buckets);
}
